/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useState, useRef } from "react";

const OtpInputField = ({ numInputs,inputs,setInputs,error,seterror,otpError,setotpError }) => {
    const refs = useRef([]);
    const handleChange = (e, index) => {
        let value = e.target.value;
        value = value.split("").at(-1)
        setInputs((prevInputs) => {
            const newInputs = [...prevInputs];
            newInputs[index] = value;
            return newInputs;
        });
      
        if (value.length === 1 && index < numInputs - 1) {
            const nextInput = refs.current[index + 1];
            nextInput.focus();

        }
    };
  
      
    const handlePaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData("text");
        const pastedChars = pastedData.split("").slice(0, numInputs);
        setInputs(pastedChars);

        if (pastedChars.length > 0) {
            refs.current[pastedChars.length - 1].focus();
        }
    };
    const handleKeyDown = (e, index) => {
        if (e.keyCode === 8 && index > 0) {
            if (inputs[index] === "") {
                refs.current[index - 1].focus();
                setInputs((prevInputs) => {
                    const newInputs = [...prevInputs];
                    newInputs[index - 1] = "";
                    return newInputs;
                });
            } else {
                refs.current[index].focus();
                setInputs((prevInputs) => {
                    const newInputs = [...prevInputs];
                    newInputs[index] = "";
                    return newInputs;
                });
            }
        }
    };
    return (
        <div className="flex justify-center items-center">
            {inputs.map((value, index) => (
                <input
                    key={index}
                    type="text"
                    id={`digit-${index+1}`}
                    pattern="[0-9]*"
                    value={value}
                    style={{borderBottom:`2px solid ${(!error || !otpError )?'#000000':'#ED1C24'}`,color:`${(!otpError )?'#000000':'#ED1C24'}`}}
                    onFocus={() => {
                        seterror(false);
                        setotpError('');
                    }
                    }
                    className={`w-6 h-10 mr-2  bg-[#fff] outline-0 text-center text-f3 font-normal text-[#000000]`}
                    onChange={(e) => {
                        if (!/[^0-9]/g.test(e.target.value)) {
                            handleChange(e, index);
                        }
                    }}
                    onPaste={handlePaste}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    ref={(el) => (refs.current[index] = el)}
                />
            ))}
        </div>
    );
};

export default OtpInputField;
